export const AlertTypeInfo    = 'info';
export const AlertTypeSuccess = 'success';
export const AlertTypeError   = 'error';